<template>
  <!--<div>-->
    <div class="page-content">
      <!-- コンテンツ情報表示前 -->
      <div class="inner" v-if="!contents" />
      <div class="inner" v-show="contents">
        <!-- お知らせ -->
        <div id="purchased-news-container" class="iframe-container" v-show="!isCarrier(platformName) && showNews">
          <iframe id="purchased-news" :src="newsUrl" scrolling="no" frameborder="0"></iframe>
        </div>
        <template v-if="contents">
          <!-- コンテンツ情報あり -->
          <template v-if="0 < contents.length">
            <div class="card-contents" v-for="detail in contents" :key="detail.contentid">
              <div class="flexcenternowrap" @click="showDetail(detail)">
                <div class="cover-image"><img :src="getContentsThumbnailPath(detail.contentid, showScreen) " :alt="detail.content_name"></div>
                <div class="detail-content">
                  <div class="flexbetween">
                    <div class="content-name font28">{{ detail.content_name }}</div>
                  </div>
                  <div class="content">
                    <div class="rate">
                      <span v-if="detail.progress == 100">★</span>
                    </div>
                    <div class="progress">
                      <p>学習進捗状況</p>
                      <div class="flexbox">
                        <div class="progress-bar">
                          <div class="data" :style="{ width: detail.progress + '%' }" />
                        </div>
                        <div class="percentage font14">{{ detail.progress }}%</div>
                      </div><!-- flexbox -->
                    </div><!-- progress -->
                  </div><!-- content -->
                  <div class="content-button">
                    <button><img src="static/images/icon/png/ar_r_circle_gray.png"></button>
                  </div>
                </div><!-- detail-content -->
              </div><!-- flexcenter -->
            </div><!-- card-contents v-for(contents) -->
          </template>
          
          <!-- コンテンツ情報なし(モバイルアプリ版) -->
          <template v-else-if="isMobile">
            <div class="no-contents">
              <div v-if="!isPlatformiOS(platformName)" class="align-center">
                <p class="font24">購入済みのコンテンツがありません</p>
                <p>ストアよりコンテンツを購入できます。</p>
              </div>
              <div v-else class="align-center">
                <p class="font24">AppStoreでご購入済みの場合</p>
                <p>右上の[?]-[復元する]を選択します</p>
                <p class="font24">上記以外でご購入済みの場合</p>
                <p>右上の[?]-[PCや別の端末と連携する]からサインインします</p>
              </div>
              <div class="content-button">
                <button type="button" @click="$emit('changeView', 'StoreList')">コンテンツを購入する</button>
              </div>
            </div><!-- no-contents -->
          </template>
          
          <!-- コンテンツ情報なし(PC版) -->
          <template v-else>
            <div class="no-contents">
              <div class="align-center">
                <p class="font24">利用開始済みのコンテンツがありません</p>
                <div>コンテンツ未購入の場合は、ストアよりご購入ください。</div>
                <div>購入済みのコンテンツがある場合は、マイページより利用開始手続きを行なってください</div>
                <p>マイページは <a href="https://www.sourcenext.com/users/action/utop" target="_blank">こちら>></a></p>
              </div>
              <div class="content-button">
                <button type="button" @click="$emit('changeView', 'StoreList')">コンテンツを購入する</button>
              </div>
            </div><!-- no-contents -->
          </template>
        </template>
        
      </div>
      <ContentDeactivation v-if="showContentDeactivation" :contentDetail="deactivateContent" @close="showContentDeactivation = false" @deactivate="doContentDeactivate"/>
    </div><!-- page-content -->
  <!-- </div> -->
</template>

<script>
import common from "@/mixin/common";
import http from "@/mixin/http";
import * as constants from "@/mixin/constants";
import ContentDeactivation from "@/components/purchased/ContentDeactivation";

export default {
  name: "purchasedList",
  props: {
    platformName: String
  },
  data: function() {
    return {
      contents: null,
      showScreen: "PurchasedList",
      showNews: false,
      deactivateContent: null,
      showContentDeactivation: false
    };
  },
  components: {
    ContentDeactivation
  },
  mixins: [
    common,
    http
  ],
  computed: {
    isMobile: () => window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME),
    newsUrl: function() {
      if (this.isMobile) {
        return process.env.PURCHASE_NOTICE_URL_SP;
      } else {
        return process.env.PURCHASE_NOTICE_URL_PC;
      }
    }
  },
  created: function() {
    this.log("PurchasedList start created");
    this.$emit("setViewName", "学習");
  },
  mounted: function() {
    this.log("PurchasedList start mounted");

    // コンテンツ一覧情報を取得し画面に設定する
    this.setContents();
    // お知らせの設定
    this.setNews();
  },
  methods: {
    /**
     * コンテンツ一覧情報を取得し画面に設定する
     */
    setContents: async function() {
      var self = this;
      this.log("PurchasedList start setContents");
      this.contents = null;

      this.getUserRegistrationInfo();

      if (this.isPlatformiOS(this.platformName)) {
        var accessKey = await storage_wrapper.getRsAccessKey();
        if (!accessKey) {
          // コンテンツマスタ情報一覧を取得し画面に設定する
          self.setMasterContent();
          return;
        }
      }

      // 購入済みコンテンツ更新APIを実行
      this.updateContentList().then(function(response) {
        self.log("PurchasedList updateContentList result_code: " + response.result_code);
        switch (response.result_code) {
          case "INFO_INVALID_ACCESSKEY":
            self.showErrorInvalidAccessKey();
            break;
          default:
            // コンテンツ情報一覧取得APIを実行
            self.getContentList().then(function(response) {
              self.log("PurchasedList getContentList result_code: " + response.result_code);
              self.commonSetContents(response);
            }).catch(function(err) {
              self.log("PurchasedList setContents error");
              self.contents = [];
              self.$emit("setMenuVisible", 0 < self.contents.length);
            });
            break;
        }
      }).catch(function(err) {
        self.log("PurchasedList setContents error");
        self.contents = [];
        self.$emit("setMenuVisible", 0 < self.contents.length);
      });
    },
    /**
     * コンテンツマスタ情報一覧を取得し画面に設定する
     */
    setMasterContent: function() {
      this.log("PurchasedList start setMasterContent");
      const self = this;

      // コンテンツマスタ情報一覧取得APIを実行
      this.getMasterContentList().then(function(response) {
        self.commonSetContents(response);
      }).catch(function(err) {
        self.log("PurchasedList setMasterContent error");
        self.contents = [];
        self.$emit("setMenuVisible", 0 < self.contents.length);
      });
    },
    /**
     * コンテンツ設定共通処理（コンテンツ情報一覧／コンテンツマスタ情報一覧取得後の共通処理）
     */
    commonSetContents: function(response) {
      this.log("common commonSetContents result_code: " + response.result_code);
      const self = this;

      switch (response.result_code) {
        case "OK":
          self.contents = [];
          var push = Array.prototype.push;
          for (var category of response.categories) {
            push.apply(self.contents, category.contents.filter(function(content) { return self.isVisibleContent(content); }));
          }
          break;
        case "INFO_INVALID_ACCESSKEY":
          self.showErrorInvalidAccessKey();
          break;
        default:
          self.contents = [];
          break;
      }
      if (self.contents) {
        self.$emit("setMenuVisible", 0 < self.contents.length);
      }
    },
    /**
     * コンテンツを画面に表示するか否かを返す
     *
     * @param {Object} content コンテンツ情報
     * @return {Boolean} true：表示する, false：表示しない
     */
    isVisibleContent: function(content) {
      // 未購入コンテンツは表示しない
      if (!content.purchased) {
        return false;
      }
      // パック製品は表示しない
      if (content.is_setitem) {
        return false;
      }
      // 非表示コンテンツは表示しない
      if (this.isInvisibleContent(content.contentid)) {
        return false;
      }
      // iOSの場合
      if (this.isPlatformiOS(this.platformName)) {
        // iOS非表示コンテンツは表示しない
        if (constants.INVISIBLE_CONTENTS_IOS.includes(content.contentid)) {
          return false;
        }
      }
      // 上記以外は表示する
      return true;
    },
    /**
     * アクセスキー無効エラーダイアログ表示
     */
    showErrorInvalidAccessKey: function() {
      var message = "INFO_INVALID_ACCESSKEY";
      var buttonKind = constants.ERROR_BUTTON_KIND_LOGIN;
      this.$emit("showError", message, buttonKind);
    },
    /**
     * 不明なエラーダイアログ表示
     */
    showErrorUnknown: function() {
      let message = constants.ERR_UNKNOWN;
      let buttonKind = "";
      this.$emit("showError", message, buttonKind);
    },
    /**
     * お知らせの設定
     */
    setNews: async function(url) {
      this.showNews = await this.isAccessUrl(this.newsUrl);
    },
    /**
     * 詳細画面を表示する
     *
     * @param {Object} contentsDetail コンテンツ情報
     */
    showDetail: function(contentsDetail) {
      if(this.showContentDeactivation) {
        return;
      }
      
      this.log("PurchasedList start showDetail");
      // GoogleAnalyticsイベントヒット送信
      rosettaGA.sendEvent(
        this.getGaEventCategoryByPlatformName(constants.GA_EVENT.GATEGORY.LEARNING, this.platformName),
        constants.GA_EVENT.ACTION.CLICK,
        contentsDetail.content_name,
        [contentsDetail.contentid]
      );
      this.$emit("changeView", "PurchasedDetail", contentsDetail);
    },
    /**
     * コンテンツ利用中止ダイアログ表示
     *
     * @param {Object} contentDetail コンテンツ情報
     */
    doShowContentDeactivation: function(contentDetail) {
      this.log("PurchasedList start doShowContentDeactivation");
      
      this.deactivateContent = contentDetail;
      this.showContentDeactivation = true;
    },
    /**
     * コンテンツ利用中止処理
     *
     * @param {Object} contentDetail コンテンツ情報
     */
    doContentDeactivate: function(contentDetail) {
      this.log("PurchasedList start doContentDeactivate");
      const self = this;
      
      // 処理中プログレス表示
      this.$emit("showProcessing", true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/common";
@import "src/assets/style/study_list";
</style>



// WEBPACK FOOTER //
// PurchasedList.vue?388c7bc6